export const STATUS_FINE_CANCELLED = 7
export const STATUS_CLAIM_WAITING = 0

export const STATUS_CLAIM_UNCLAIMED = -1
export const STATUS_CLAIM_AWAITING = 0
export const STATUS_CLAIM_SOLVE = 1
export const STATUS_CLAIM_DENIED = 2

export const SOPPORTED_CLAIMS_STATUS = [
    STATUS_CLAIM_UNCLAIMED,
    STATUS_CLAIM_AWAITING,
    STATUS_CLAIM_SOLVE,
    STATUS_CLAIM_DENIED,
]
